module.exports = __webpack_public_path__ + "assets/icons/favicon-loki-2e74.ico";